/**
 * Ray Accordion
 *
 * Generic toggle for snippets/ray-accordion-item.liquid. Wires up every
 * [data-ray-accordion-item] on the page (not scoped to one section), independent open/close per
 * item, no exclusivity. Height animation itself is pure CSS (grid-template-rows) - this just
 * flips data-open/aria-expanded.
 */
(() => {
  if (window.RayAccordionInitialized) return;

  window.RayAccordionInitialized = true;

  const initItem = (item) => {
    if (item.dataset.rayAccordionInitialized === 'true') return;

    item.dataset.rayAccordionInitialized = 'true';

    const button = item.querySelector('.ray-accordion-item__summary');

    if (!button) return;

    button.addEventListener('click', () => {
      const isOpen = item.getAttribute('data-open') === 'true';

      item.setAttribute('data-open', isOpen ? 'false' : 'true');
      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  };

  const initAll = (rootNode = document) => {
    rootNode.querySelectorAll('[data-ray-accordion-item]').forEach(initItem);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => initAll());
})();
